import { ReactNode } from 'react';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import { TotalizerCard, TotalizerCardShell } from './TotalizerCard';

interface FicFidcFundsTotalizerProps {
  isLoading: boolean;
  value: ReactNode;
  complement: string;
}

export function FicFidcFundsTotalizer({
  isLoading,
  value,
  complement,
}: FicFidcFundsTotalizerProps) {
  return (
    <TotalizerCard
      ariaLabel="Totalizador de fundos monitorados"
      complement={complement}
      icon={
        <VisibilityOutlinedIcon
          color="info"
          aria-hidden
          data-testid="fic-fidc-funds-icon"
        />
      }
      isLoading={isLoading}
      label="Fundos monitorados"
      totalizerId="fic-fidc-funds-totalizer"
      value={value}
    />
  );
}

export function FicFidcFundsCard(props: FicFidcFundsTotalizerProps) {
  return (
    <TotalizerCardShell accent="info" cardId="fic-fidc-funds-card">
      <FicFidcFundsTotalizer {...props} />
    </TotalizerCardShell>
  );
}
